const FIRST_TOUCH_KEY = 'bb_attribution_first_touch';
const FALLBACK_APP_LOGIN_URL = '/v2/login';
const LEGACY_SIGNUP_CTA_SELECTOR = [
    '#signupButtonFooter',
    '#signupButtonHeader',
    '#signupButtonMobile',
    '#signupButtonHero',
    '#signupButtonHeroMobile',
    '#signupButtonPremiumVoice',
    '.js-auth-cta[data-auth-action="signup"]',
].join(', ');
const SIGNUP_HASH = '#signup';
const SIGNUP_HASH_PATH = `/${SIGNUP_HASH}`;

function resolveAuthUrl(mode) {
    const rawLoginUrl = (import.meta.env.VITE_APP_LOGIN_URL || FALLBACK_APP_LOGIN_URL).trim();

    try {
        const authUrl = new URL(rawLoginUrl, window.location.origin);
        if (mode) {
            authUrl.searchParams.set('mode', mode);
        }

        return authUrl.toString();
    } catch (error) {
        if (import.meta.env.MODE === 'development') {
            console.warn('header: invalid VITE_APP_LOGIN_URL, falling back to local /v2/login:', error?.message || error);
        }

        return mode ? `${FALLBACK_APP_LOGIN_URL}?mode=${encodeURIComponent(mode)}` : FALLBACK_APP_LOGIN_URL;
    }
}

function pushAuthCtaClick({ action, location }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'auth_cta_click',
        authAction: action,
        ctaLocation: location,
    });
}

function getCurrentPageContext() {
    const path = window.location.pathname || '/';
    const fileName = path.substring(path.lastIndexOf('/') + 1);
    return fileName.replace(/\.html$/, '') || 'homepage';
}

function toSnakeCase(value) {
    return value
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/[-\s]+/g, '_')
        .toLowerCase();
}

function deriveAuthLocation(element) {
    if (element.dataset?.authLocation) {
        return element.dataset.authLocation;
    }

    if (element.id) {
        return toSnakeCase(element.id.replace(/^(signupButton|loginButton)/, '')) || 'signup';
    }

    return 'inline_hash_link';
}

function resolveSignupUrlWithContext(context) {
    try {
        const signupUrl = new URL(resolveAuthUrl('signup'), window.location.origin);
        signupUrl.searchParams.set('context', context);
        return signupUrl.toString();
    } catch (error) {
        if (import.meta.env.MODE === 'development') {
            console.warn('header: failed to append signup context, falling back to plain signup URL:', error?.message || error);
        }

        return resolveAuthUrl('signup');
    }
}

function pushLegacySignupCtaClick({ location, pageContext }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'auth_cta_click',
        authAction: 'signup',
        ctaLocation: location,
        auth_location: location,
        auth_industry_context: pageContext,
    });
}

function interceptLegacySignupCta(event) {
    if (!(event.target instanceof Element)) return;

    const matchedLegacyTarget = event.target.closest(LEGACY_SIGNUP_CTA_SELECTOR);
    const matchedHashLink = event.target.closest('a[href]');
    const target = matchedLegacyTarget
        || ([SIGNUP_HASH, SIGNUP_HASH_PATH].includes(matchedHashLink?.getAttribute('href')) ? matchedHashLink : null);

    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    const pageContext = getCurrentPageContext();
    const location = deriveAuthLocation(target);

    pushLegacySignupCtaClick({ location, pageContext });
    window.location.href = resolveSignupUrlWithContext(pageContext);
}

function wireAuthLink(element, { action, location, mode }) {
    if (!element) return;

    element.href = resolveAuthUrl(mode);
    element.addEventListener('click', () => {
        pushAuthCtaClick({ action, location });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', interceptLegacySignupCta, { capture: true });

    const hamburgerButton = document.getElementById('hamburger-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const loginButtonMobile = document.getElementById('loginButtonMobile');
    const loginButton = document.getElementById('loginButton');
    const signupButtonHeader = document.getElementById('signupButtonHeader');
    const signupButtonMobile = document.getElementById('signupButtonMobile');
    const signupButtonHero = document.getElementById('signupButtonHero');
    const signupButtonFooter = document.getElementById('signupButtonFooter');
    const signupButtonPremiumVoice = document.getElementById('signupButtonPremiumVoice');
    const featuresDropdown = document.getElementById('features-dropdown');
    const featuresMenu = document.getElementById('features-menu');
    const solutionsDropdown = document.getElementById('solutions-dropdown');
    const solutionsMenu = document.getElementById('solutions-menu');
    const useCasesDropdown = document.getElementById('use-cases-dropdown');
    const useCasesMenu = document.getElementById('use-cases-menu');
    const featuresDropdownMobile = document.getElementById('features-dropdown-mobile');
    const featuresMenuMobile = document.getElementById('features-menu-mobile');
    const solutionsDropdownMobile = document.getElementById('solutions-dropdown-mobile');
    const solutionsMenuMobile = document.getElementById('solutions-menu-mobile');
    const useCasesDropdownMobile = document.getElementById('use-cases-dropdown-mobile');
    const useCasesMenuMobile = document.getElementById('use-cases-menu-mobile');

    const closeMenus = (menus = []) => {
        menus.forEach((currentMenu) => {
            if (currentMenu) {
                currentMenu.classList.add('hidden');
            }
        });
    };

    const setupDesktopDropdown = (dropdown, menu, siblingMenus = []) => {
        if (!dropdown || !menu) return;

        const button = dropdown.querySelector('button');
        if (!button) return;

        button.addEventListener('click', (event) => {
            event.stopPropagation();

            const isHidden = menu.classList.contains('hidden');
            closeMenus(siblingMenus);

            if (isHidden) {
                menu.classList.remove('hidden');
                return;
            }

            menu.classList.toggle('hidden');
        });
    };

    const setupMobileDropdown = (dropdown, menu, siblingMenus = []) => {
        if (!dropdown || !menu) return;

        const button = dropdown.querySelector('button');
        if (!button) return;

        button.addEventListener('click', (event) => {
            event.stopPropagation();

            const isHidden = menu.classList.contains('hidden');
            closeMenus(siblingMenus);

            if (isHidden) {
                menu.classList.remove('hidden');
                return;
            }

            menu.classList.toggle('hidden');
        });
    };

    if (hamburgerButton) {
        hamburgerButton.addEventListener('click', () => {
            mobileMenu.classList.toggle('hidden');
        });
    }

    wireAuthLink(loginButton, { action: 'login', location: 'header_desktop' });
    wireAuthLink(loginButtonMobile, { action: 'login', location: 'header_mobile' });
    wireAuthLink(signupButtonHeader, { action: 'signup', location: 'header_desktop', mode: 'signup' });
    wireAuthLink(signupButtonMobile, { action: 'signup', location: 'header_mobile', mode: 'signup' });
    wireAuthLink(signupButtonHero, { action: 'signup', location: 'hero', mode: 'signup' });
    wireAuthLink(signupButtonFooter, { action: 'signup', location: 'footer', mode: 'signup' });
    wireAuthLink(signupButtonPremiumVoice, { action: 'signup', location: 'premium_voice', mode: 'signup' });

    setupDesktopDropdown(featuresDropdown, featuresMenu, [solutionsMenu, useCasesMenu]);
    setupDesktopDropdown(solutionsDropdown, solutionsMenu, [featuresMenu, useCasesMenu]);
    setupDesktopDropdown(useCasesDropdown, useCasesMenu, [featuresMenu, solutionsMenu]);
    setupMobileDropdown(featuresDropdownMobile, featuresMenuMobile, [solutionsMenuMobile, useCasesMenuMobile]);
    setupMobileDropdown(solutionsDropdownMobile, solutionsMenuMobile, [featuresMenuMobile, useCasesMenuMobile]);
    setupMobileDropdown(useCasesDropdownMobile, useCasesMenuMobile, [featuresMenuMobile, solutionsMenuMobile]);

    document.addEventListener('click', () => {
        closeMenus([featuresMenu, solutionsMenu, useCasesMenu]);
    });

    // --- First-Touch Attribution Capture (UTMs + referrer, including direct) ---
    try {
        const params = new URLSearchParams(window.location.search || '');

        if (typeof window !== 'undefined' && window.localStorage) {
            // Only capture on the very first touch; never overwrite.
            if (!localStorage.getItem(FIRST_TOUCH_KEY)) {
                const payload = {
                    utm_source: params.get('utm_source') || null,
                    utm_medium: params.get('utm_medium') || null,
                    utm_campaign: params.get('utm_campaign') || null,
                    utm_content: params.get('utm_content') || null,
                    utm_term: params.get('utm_term') || null,
                    landing_path: window.location.pathname + window.location.search,
                    // This is the original referrer for the first touch; may be null for true direct.
                    referrer: document.referrer || null,
                    captured_at: new Date().toISOString(),
                };
                localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(payload));
            }
        }
    } catch (e) {
        if (import.meta.env.MODE === 'development') {
            console.warn('header: failed to capture first-touch attribution:', e?.message || e);
        }
    }
});

export { resolveAuthUrl, pushAuthCtaClick };
